import { cn } from "@design-system/utils";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { CheckIcon } from "lucide-react";
import * as React from "react";

export type CheckboxProps = React.ComponentProps<typeof CheckboxPrimitive.Root>;

function Checkbox({ className, ...props }: CheckboxProps) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        "bg-shape-neutral-outlined-background border-shape-neutral-outlined-border-emphasised data-[state=checked]:bg-shape-neutral-inverted-background data-[state=checked]:text-shape-neutral-inverted-foreground-default data-[state=checked]:border-shape-neutral-outlined-border-emphasised focus-visible:ring-ring-default aria-invalid:ring-ring-default aria-invalid:border-shape-critical-outlined-border-emphasised peer size-4 shrink-0 cursor-pointer rounded-[4px] border shadow-xs transition-shadow outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="flex items-center justify-center text-current transition-none"
      >
        <CheckIcon className="size-3.5" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}

export { Checkbox };
